<div
  *ngIf="!consentGiven && consent === undefined && enabled"
  class="cookie"
  role="dialog"
  [ngStyle]="accentVars"
  aria-label="Analytics consent"
>
  <div class="cookie__inner">
    <div class="cookie__copy">
      <b>Help us improve the app</b>
      <p class="m-0">
        We use analytics to understand how the app is used so we can make it
        better. We do not collect personal information without your consent.
      </p>
    </div>
    <div class="cookie__actions">
      <button
        type="button"
        class="ui-btn ui-btn--ghost ui-btn--sm"
        (click)="declineConsent()"
      >
        Decline
      </button>
      <button type="button" class="ui-btn ui-btn--sm" (click)="acceptConsent()">
        Allow analytics
      </button>
    </div>
  </div>
</div>
